<div class="row">
  <div class="backdrop go-in" id="backdrop">
    <!-- <div class="sign-in"> -->
    <div class="confetti" [hidden]="!this.gamePlayService.addLeaderBoard">
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
    </div>
    <div #didU class="did-you-know new-player flex-align scale-in-pop"
      [ngClass]="{'new-player-match': game.kind == 'match', 'new-player-trivia': game.kind == 'trivia'}">
      <div class="flex-between">
        <img src="../../../assets/images/icons/money.png" class="coin-new-player">
        <h1 class="score-new-player">{{score}}</h1>
      </div>
      <h1 style="margin-top: 50px;
      font-weight: 600;" [innerText]="gamePlayService.addLeaderBoard ? 'נכנסת לטבלת האלופים!' : 'סוף משחק'" [ngStyle]="{'font-size': gamePlayService.addLeaderBoard ? '60px' : '110px'}"></h1>
      <div style="margin-top: 50px;
      font-size: 30px;
      font-weight: 500; color: white;" *ngIf="gamePlayService.addLeaderBoard">הכנס שם:</div>
      <input type="text" [(ngModel)]="name" style="outline: none; border-radius: 26px;
      width: 300px;
      height: 70px;
      margin-top: 20px;     font-size: 30px;
    font-weight: 500;
    text-align: center;" *ngIf="gamePlayService.addLeaderBoard">
      <div class="match-data-container" style="position: absolute;
        bottom: 40px;
        left: 40px; background-color: #e9eaeb;" [ngStyle]="{'width': gamePlayService.addLeaderBoard ? '215px' : '320px'  }" (click)="submit(didU)">
        <div class="white-circle">
          <img src="./assets/images/icons/hand.png" style="transform: scale(0.17) translate(36px, 0);">
        </div>
        <h2 style="    color: #004f80;
          width: auto;     font-weight: 800; text-align: center; " [innerText]="gamePlayService.addLeaderBoard ? 'המשך' : 'לתפריט הראשי'"></h2>
      </div>
    </div>
  </div>
</div>